import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { PastureController } from 'src/controllers/pasture.controller'
import { PastureHistoricDto } from 'src/dto/pasture.dto'

const pastureController = new PastureController()

export function useGetPastureHistoricById(id: string) {
  const { userFarm: farmId } = useAuth()

  return useQuery<PastureHistoricDto[], Error>({
    queryKey: ['getPastureHistoricById', farmId, id],
    queryFn: () => pastureController.getPastureHistoricById(farmId!, id),
    enabled: !!farmId && !!id
  })
}
